module.exports = __webpack_public_path__ + "img/skrill.4bf9303b.svg";